import ApiAccess from "@/services/ApiAccess.js";

export const state = {
  adventures: [],
  adventure: Object
};

export const mutations = {
  SET_ADVENTURES(state, adventures) {
    state.adventures = adventures;
  },
  ADD_ADVENTURE(state, adventure) {
    state.adventures.push(adventure);
  }
};

export const actions = {
  fetchAdventures({ commit, dispatch }) {
    return ApiAccess.getAdventures()
      .then(response => {
        var adventures = response.data.data.reverse();
        commit("SET_ADVENTURES", adventures);
        return adventures;
      })
      .catch(error => {
        dispatch(
          "setNotification",
          "Error Fetching Adventures: " + error.message,
          {
            root: true
          }
        );
      });
  },
  createAdventure({ commit, dispatch, rootState }, adventure) {
    dispatch(
      "setNotification",
      "User " + rootState.UserStore.user.name + " is creating adventure",
      {
        root: true
      }
    );

    ApiAccess.addAdventure(adventure, rootState.UserStore.token)
      .then(() => {
        console.log("success");
        commit("ADD_ADVENTURE", adventure);
      })
      .catch(error => {
        console.log(error);
        dispatch(
          "setNotification",
          "Error Creating Adventure: " + error.message,
          {
            root: true
          }
        );
      });
  }
};
